<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1" id="title"><a id="page_3"></a>The Akashic Records</h1>
<p class="subtitle">Sacred Exploration of Your Soul’s journey Within<br/>the Wisdom of the Collective Consciousness</p>
<p class="center"><img alt="images" src="images/puba.jpg"/></p>
<p class="author">By Ernesto Ortiz</p>
<p class="pub"><img alt="images" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?0608e009